import { ActivityEntityName, JobTemplateWorkOrder } from '@jms/model';
import { registerManifest } from '@workbuddy/services/entities/entity.manifest.registry';
import { JobTemplateRelationName } from '../work.job.template/relation.names';

/**
 * Relations only: a template stage has no board, route or surface of its own — it is reached through the
 * record page's rail. Same shape as `work.order`, an entity that exists so a parent can mount children.
 */
export const jobTemplateStageManifest = registerManifest<JobTemplateWorkOrder>({
  entity: ActivityEntityName.JobTemplateStage,

  relations: {
    [JobTemplateRelationName.Items]: () => import('./relations/job.template.stage.items.relation').then(module => module.jobTemplateStageItemsBoardBuilder),
    [JobTemplateRelationName.Tasks]: () => import('./relations/job.template.stage.tasks.relation').then(module => module.jobTemplateStageTasksBoardBuilder),
  },
});
